import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {AuthenticationService, authUserType} from 'app/services/auth.service';
import { APIService } from 'app/services/api.service';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import {login} from "app/_helpers/login";
import {HttpErrorResponse} from "@angular/common/http";
import {throwError as observableThrowError} from "rxjs";

@Component({
  templateUrl: './sessioncheck.component.html'
})

export class SessionCheckComponent implements OnInit {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  constructor() { }

  ngOnInit() {
    this.loaderService.display(true, 'sessioncheck');
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];

    this.api.get(this.config.login.getSessionUrl).subscribe({
      next: data => {
        const authUser = data as authUserType;
        this.auth.logUserIn(authUser).subscribe(() => {
          login(this.auth, this.router, this.route, authUser, returnUrl, null);
          this.loaderService.display(false, 'sessioncheck');
        });
      },
      error: error => {
        if (error instanceof HttpErrorResponse) {
          const httpErrorResponse = error as HttpErrorResponse;
          if (httpErrorResponse.status === 401) {
            const extras: NavigationExtras = {};
            if (returnUrl !== '/welcome') {
              extras.queryParams = { returnUrl };
            }
            this.router.navigate(['/account/login'], extras);
            this.loaderService.display(false, 'sessioncheck');
            return;
          }
        }
        return observableThrowError(error);
        // What do we do with other errors? They are not recoverable so does it matter?
        // We could redirect to the login page but that might be frustrating to the user
      },
    });
  }
}
